export default __webpack_public_path__ + "static/media/9_estabelecimento-ensino.20d533c1.png";